export default __webpack_public_path__ + "static/FeatureFour-72aabf96f3a1e81fd3057d6acda8f29d.webp";